import type { StripeElementLocale } from '@stripe/stripe-js';

const STRIPE_LOCALES = new Set<StripeElementLocale>([
  'auto',
  'ar',
  'bg',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'en-GB',
  'es',
  'es-419',
  'et',
  'fi',
  'fil',
  'fr',
  'fr-CA',
  'he',
  'hr',
  'hu',
  'id',
  'it',
  'ja',
  'ko',
  'lt',
  'lv',
  'mt',
  'ms',
  'nl',
  'no',
  'pl',
  'pt',
  'pt-BR',
  'ro',
  'ru',
  'sk',
  'sl',
  'sv',
  'th',
  'tr',
  'vi',
  'zh',
  'zh-HK',
  'zh-TW',
]);

export function resolveStripeLocale(language: string): StripeElementLocale {
  const normalized = language.trim().replace('_', '-').toLowerCase();
  if (!normalized) {
    return 'auto';
  }

  const regionMap: Record<string, string> = {
    'en-gb': 'en-GB',
    'pt-br': 'pt-BR',
    'zh-hk': 'zh-HK',
    'zh-tw': 'zh-TW',
  };

  const mapped = regionMap[normalized] as StripeElementLocale | undefined;
  if (mapped && STRIPE_LOCALES.has(mapped)) {
    return mapped;
  }

  const base = normalized.split('-')[0];
  return STRIPE_LOCALES.has(base as StripeElementLocale) ? (base as StripeElementLocale) : 'auto';
}

